import { parseFromValuesOrFunc } from 'blocks/cx-data-table/utils/utils'
import clsx from 'clsx'
import { useEffect, useLayoutEffect, useState } from 'react'
import type { DataTableInstance, DataTableRowData } from '../../types'
import { DataTable } from './table'

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect

interface Props<TData extends DataTableRowData> {
  table: DataTableInstance<TData>
}

export const TableContainer = <TData extends DataTableRowData>({
  table,
  ...rest
}: Props<TData>) => {
  const {
    options: { enableStickyHeader, cxTableContainerProps },
    refs: { bottomToolbarRef, topToolbarRef },
  } = table

  const [totalToolbarHeight, setTotalToolbarHeight] = useState(0)

  const tableContainerProps = {
    ...parseFromValuesOrFunc(cxTableContainerProps, { table }),
    ...rest,
  }

  useIsomorphicLayoutEffect(() => {
    const topToolbarHeight =
      typeof document !== 'undefined' ? (topToolbarRef.current?.offsetHeight ?? 0) : 0

    const bottomToolbarHeight =
      typeof document !== 'undefined' ? (bottomToolbarRef?.current?.offsetHeight ?? 0) : 0

    setTotalToolbarHeight(topToolbarHeight + bottomToolbarHeight)
  })

  return (
    <div
      {...tableContainerProps}
      style={
        enableStickyHeader
          ? {
              maxHeight: `clamp(350px,calc(100vh - calc(var(${totalToolbarHeight}) * 1px)),9999px)`,
            }
          : {}
      }
      className={clsx(
        'mrt-table-container bg-background max-w-full overflow-auto relative',
        tableContainerProps?.className,
      )}
    >
      <DataTable table={table} />
    </div>
  )
}
